import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import { IGreenhouse, IGreenhouses, IGreenhouseState } from "../interfaces/IGreenhouse";



const initialState: IGreenhouseState = {
    greenhouses: [],
    greenhouse: {
        id: 0,
        name: '',
        code: '',
        description: '',
        acronym: '',
        length: 0,
        width: 0,
        size: 0,
        allocatedSpace: 0,
        availableSpace: 0,
        heatedFloors: false,
        bays: [],
        createdAt: new Date,
        updatedAt: new Date
    }
}

export const greenhouseSlice = createSlice({
    name: 'greenhouse',
    initialState,
    reducers: {
        setGreenhouseValues: (state, action: PayloadAction<IGreenhouseState>) => {
            state.greenhouse = action.payload.greenhouse;
        },
        setGreenhouses: (state, action: PayloadAction<IGreenhouseState>) => {
            state.greenhouses = action.payload.greenhouses
        }
    }
})

export const {setGreenhouseValues, setGreenhouses} = greenhouseSlice.actions;

export const selectGreenhouse = (state: RootState) => state.greenhouse;
export const selectGreenhouses = (state: RootState) => state.greenhouses;

export default greenhouseSlice.reducer;